import React, { forwardRef } from "react";

import styled from "styled-components/macro";

import { InputWrapper } from "UI/FnrInput/";
import { HoverParent } from "UI/HoverChildren";

const FnrToggle = forwardRef(
  (
    {
      children,
      triggerResize,
      style,
      disabled,
      hoverStyle = {},
      CustomSelectedElement,
      CustomHoverElement,
      allowOverflow,
    },
    ref
  ) => {
    return (
      <Wrapper
        ref={ref}
        style={style}
        className="FnrToggle"
        $allowOverflow={allowOverflow}
      >
        <HoverParent
          allowOverflow={allowOverflow}
          disabled={disabled}
          triggerResize={triggerResize}
          hoverStyle={{
            borderRadius: 2,
            ...hoverStyle,
          }}
          CustomSelectedElement={CustomSelectedElement}
          CustomHoverElement={CustomHoverElement}
        >
          {children}
        </HoverParent>
      </Wrapper>
    );
  }
);

const Wrapper = styled(InputWrapper)`
  padding: 2px;
  color: #475b68;
  user-select: none;
  overflow: ${({ $allowOverflow }) => ($allowOverflow ? "visible" : "hidden")};
  width: auto;
`;

const FnrToggleItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  color: #475b68;
  z-index: 100;
  position: relative;
`;

export { FnrToggle, FnrToggleItems };
